import { render, staticRenderFns } from "./LoadingFallback.vue?vue&type=template&id=698f61d7&"
import script from "./LoadingFallback.vue?vue&type=script&lang=js&"
export * from "./LoadingFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports